import type { SendbirdProviderProps } from '@sendbird/uikit-react/SendbirdProvider';

export const uiKitOptions: NonNullable<SendbirdProviderProps['uikitOptions']> =
    {
        groupChannel: {
            enableTypingIndicator: false,
            enableMention: false,
            enableReactions: false,
            enableVoiceMessage: false,
            replyType: 'none' as 'none' | 'quote_reply',
            enableMarkdownForUserMessage: true, // Enable markdown formatting. Currently only Bold and Links are supported. See https://sendbird.com/docs/ai-chatbot/guide/v1/uikit/markdown-message.
        },
        groupChannelSettings: {
            enableMessageSearch: true,
        },
    };
